import Vue from 'vue';
const $eventBus = new Vue();
export default $eventBus;

export const $snackbar = {
	info(message) {
		$eventBus.$emit('show-snackbar', message);
	},
	alert(message) {
		$eventBus.$emit('show-snackbar', 'alert', message);
	},
	error(message) {
		$eventBus.$emit('show-snackbar', 'error', message);
	},
};
